import React, { useState, useEffect } from "react";
import ReelsSection from "../../pages/sidebarcall/ReelsSection.jsx";
import "./Userdashbord.css";
import axios from "axios";
import OfferPopup from "./OfferPopup.jsx";  

const UserDashboardHome = () => {
  // Real data state for dashboard
  const [userData, setUserData] = useState({
    name: "Vikash",
    totalOrders: 0,
    lastOrderItem: "Loading...",
    savedAddresses: 0,
    deliveredOrders: 0,
    cancelledOrders: 0,
    pendingOrders: 0,
  });

  const [recentOrders, setRecentOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const addressCount = addresses?.length || 0;
  const [isAddressLoading, setIsAddressLoading] = useState(true);


  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("authToken");

  // ✅ FIXED NAME FETCH LOGIC
  useEffect(() => {
    // 🔹 Load from localStorage first (fast UI)
    const storedName = localStorage.getItem("companyName");
    if (storedName) {
      setCompanyName(storedName);
    }

    // 🔹 If no userId → stop
    if (!userId) {
      //console.log("No userId found");
      return;
    }

    const fetchName = async () => {
      try {
        const response = await fetch(
          `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        ////console.log("API status:", response.status);

        if (!response.ok) throw new Error("Failed to fetch");

        const data = await response.json();
        ////console.log("API data:", data);

        // 🔥 HANDLE ALL POSSIBLE RESPONSE STRUCTURES
        const name =
          data?.userName ||
          data?.data?.userName ||
          data?.user?.userName;

        if (name) {
          localStorage.setItem("companyName", name);
          setCompanyName(name);
        } else {
          ////console.log("userName not found in response", data);
        }
      } catch (err) {
        //console.log("Error:", err);
      }
    };

    fetchName();
  }, [userId, token]);

  // Fetch orders and update stats
  useEffect(() => {
    const fetchOrders = async () => {
      setIsLoading(true);

      if (!userId) {
       //console.log('User ID not found in localStorage.');
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/user/orders?userId=${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        const sortedOrders = response.data.sort(
          (a, b) => new Date(b.orderDateAndTime) - new Date(a.orderDateAndTime)
        );

        setOrders(sortedOrders);
        setFilteredOrders(sortedOrders);

        // Calculate stats from orders
        const totalOrders = sortedOrders.length;
        const deliveredOrders = sortedOrders.filter(order => order.status?.toLowerCase() === 'delivered').length;
        const cancelledOrders = sortedOrders.filter(order => order.status?.toLowerCase() === 'cancelled').length;
        const pendingOrders = sortedOrders.filter(order =>
          order.status?.toLowerCase() === 'pending' ||
          order.status?.toLowerCase() === 'preparing' ||
          order.status?.toLowerCase() === 'shipped'
        ).length;

        // Get last order item name - FIXED
        let lastOrderItem = "No orders yet";
        if (sortedOrders.length > 0) {
          const lastOrder = sortedOrders[0];
          // Check order.order array (not items)
          if (lastOrder.order && lastOrder.order.length > 0) {
            lastOrderItem = lastOrder.order[0].dishName || "Food item";
          } else if (lastOrder.dishName) {
            lastOrderItem = lastOrder.dishName;
          }
        }

        // Get saved addresses count (you might have a separate API for this)
        const savedAddresses = 0; // Update this with actual addresses API if available

        setUserData({
          name: companyName || "User",
          totalOrders,
          lastOrderItem,
          savedAddresses,
          deliveredOrders,
          cancelledOrders,
          pendingOrders,
        });

        // Transform orders for recent orders display (first 5) - FIXED
        const transformedOrders = sortedOrders.slice(0, 5).map(order => ({
          id: order.orderId || order.id,
          items: order.order?.map(item => item.dishName) || [], // FIXED: use order.order
          date: order.orderDateAndTime || order.date,
          total: `₹${order.totalAmount || order.amount || order.total || 0}`,
          status: order.status?.toLowerCase() || 'pending',
          statusText: order.status?.toUpperCase() || 'PENDING',
          statusColor: getStatusColorClass(order.status)
        }));

        setRecentOrders(transformedOrders);

      } catch (error) {
       //console.log('Error fetching orders:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, [userId, token]);




const fetchAddresses = async () => {
    try {
      setIsAddressLoading(true);

      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken");

      if (!userId) {
        setIsAddressLoading(false);
        return;
      }

      const res = await axios.get(
        `https://backend.maamaas.com/subscription/api/user/get/addresses/${userId}`,
        {
          headers: token
            ? {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            }
            : {},
        }
      );

      const data = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];

      setAddresses(data);
    } catch (error) {
      setAddresses([]);
    } finally {
      setIsAddressLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  // Helper function for status color
  const getStatusColorClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered':
        return 'status-delivered-vikash';
      case 'pending':
        return 'status-pending-vikash';
      case 'cancelled':
        return 'status-cancelled-vikash';
      case 'preparing':
        return 'status-preparing-vikash';
      case 'shipped':
        return 'status-shipped-vikash';
      default:
        return 'status-default-vikash';
    }
  };

  // Get status icon
  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "delivered":
        return "✓";
      case "preparing":
        return "🔄";
      case "shipped":
        return "🚚";
      case "cancelled":
        return "✗";
      case "pending":
        return "⏳";
      default:
        return "•";
    }
  };

  // Advertisement data - real use case
  const advertisements = [
    {
      id: 1,
      title: "🔥 Summer Sale! 40% OFF",
      description: "On all pizzas & burgers",
      cta: "Order Now →",
      bgGradient: "gradient-fire",
    },
    {
      id: 2,
      title: "✨ Free Delivery",
      description: "On orders above ₹299",
      cta: "Shop Now →",
      bgGradient: "gradient-free",
    },
    {
      id: 3,
      title: "🎁 Weekend Special",
      description: "Buy 1 Get 1 Free on Pasta",
      cta: "Claim Offer →",
      bgGradient: "gradient-weekend",
    },
    {
      id: 4,
      title: "⭐ Loyalty Rewards",
      description: "Earn points on every order",
      cta: "Join Now →",
      bgGradient: "gradient-rewards",
    },
    {
      id: 5,
      title: "🚚 Super Fast Delivery",
      description: "Under 30 mins guaranteed",
      cta: "Track Now →",
      bgGradient: "gradient-fast",
    },
    {
      id: 6,
      title: "🍔 New Launch!",
      description: "Try our signature burgers",
      cta: "Explore →",
      bgGradient: "gradient-launch",
    },
  ];

  return (
    <>
     {/* <OfferPopup /> */}
    <div className="dashboard-root-vikash">
      <div className="dashboard-main-content-vikash">
        <div className="welcome-hero-card-vikash">
          <div className="welcome-hero-left-vikash">
            <h1 className="welcome-greeting-vikash">
              Welcome back, {companyName || userData.name || "User"}! 👋
            </h1>
            <p className="welcome-message-vikash">
              Track your orders, manage deliveries, and enjoy exclusive offers
            </p>
          </div>
          <div className="welcome-hero-right-vikash">
            <div className="welcome-badge-vikash">
              <span className="badge-icon-vikash">⭐</span>
              <span className="badge-text-vikash">Premium Member</span>
            </div>
          </div>
        </div>

        {/* Stats Grid - Real Data */}
        <div className="stats-grid-vikash">
          <div className="stat-card-vikash stat-card-total-vikash">
            <div className="stat-icon-vikash">📦</div>
            <div className="stat-info-vikash">
              <p className="stat-label-vikash">Total Orders</p>
              <h2 className="stat-number-vikash">
                {isLoading ? "..." : userData.totalOrders}
              </h2>
            </div>
          </div>

          <div className="stat-card-vikash stat-card-last-vikash">
            <div className="stat-icon-vikash">🍕</div>
            <div className="stat-info-vikash">
              <p className="stat-label-vikash">Last Order Item</p>
              <h2 className="stat-number-vikash stat-last-item-vikash">
                {isLoading ? "..." : userData.lastOrderItem}
              </h2>
            </div>
          </div>

          <div className="stat-card-vikash stat-card-address-vikash">
            <div className="stat-icon-vikash">📍</div>
            <div className="stat-info-vikash">
              <p className="stat-label-vikash">Saved Addresses</p>
              <h2 className="stat-number-vikash">
                {isAddressLoading ? "..." : addresses.length}
              </h2>
            </div>
          </div>

          <div className="stat-card-vikash stat-card-delivered-vikash">
            <div className="stat-icon-vikash">✅</div>
            <div className="stat-info-vikash">
              <p className="stat-label-vikash">Delivered Orders</p>
              <h2 className="stat-number-vikash stat-delivered-number-vikash">
                {isLoading ? "..." : userData.deliveredOrders}
              </h2>
            </div>
          </div>

          <div className="stat-card-vikash stat-card-cancelled-vikash">
            <div className="stat-icon-vikash">❌</div>
            <div className="stat-info-vikash">
              <p className="stat-label-vikash">Cancelled Orders</p>
              <h2 className="stat-number-vikash stat-cancelled-number-vikash">
                {isLoading ? "..." : userData.cancelledOrders}
              </h2>
            </div>
          </div>

          <div className="stat-card-vikash stat-card-pending-vikash">
            <div className="stat-icon-vikash">⏳</div>
            <div className="stat-info-vikash">
              <p className="stat-label-vikash">Pending Orders</p>
              <h2 className="stat-number-vikash stat-pending-number-vikash">
                {isLoading ? "..." : userData.pendingOrders}
              </h2>
            </div>
          </div>
        </div>

        {/* Recent Orders Section - Professional Table Design */}
        <div className="recent-orders-wrapper-vikash">
          <div className="orders-header-vikash">
            <h2 className="orders-title-vikash">📋 Recent Orders</h2>
            {/* <button className="view-all-btn-vikash">View All →</button> */}
          </div>

          {isLoading ? (
            <div className="loading-skeleton-vikash">
              <div className="skeleton-row-vikash"></div>
              <div className="skeleton-row-vikash"></div>
              <div className="skeleton-row-vikash"></div>
            </div>
          ) : recentOrders.length === 0 ? (
            <div className="no-orders-vikash">No orders found</div>
          ) : (
            <div className="orders-table-container-vikash">
              <table className="orders-table-vikash">
                <thead>
                  <tr className="orders-table-header-vikash">
                    <th>Order ID</th>
                    <th>Items</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {recentOrders.map((order) => (
                    <tr key={order.id} className="orders-table-row-vikash">
                      <td className="order-id-cell-vikash">
                        <span className="order-id-text-vikash">{order.id}</span>
                      </td>
                      <td className="order-items-cell-vikash">
                        <div className="order-items-list-vikash">
                          {order.items.map((item, idx) => (
                            <span key={idx} className="order-item-tag-vikash">
                              {item}
                              {idx < order.items.length - 1 && ", "}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td className="order-date-cell-vikash">
                        {new Date(order.date).toLocaleDateString("en-IN", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </td>
                      <td className="order-total-cell-vikash">
                        <span className="order-total-amount-vikash">
                          {order.total}
                        </span>
                      </td>
                      <td className="order-status-cell-vikash">
                        <div className={`order-status-badge-vikash ${order.statusColor}`}>
                          <span className="status-icon-vikash">
                            {getStatusIcon(order.status)}
                          </span>
                          <span>{order.statusText}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* RIGHT SIDEBAR - SCROLLABLE ADVERTISEMENT COMPONENT */}
      <div className="dashboard-sidebar-vikash">
        <ReelsSection />
      </div>
    </div>
    </>
  );
};

export default UserDashboardHome;